// 2026-09-22：功能用途与视频使用独立接口，展示查询与平台配置权限分离。
import request from '@/utils/request'
import type { FunctionGuide } from '@/utils/functionGuides'
export default {
  list: () => request({ url: 'system/functionGuides', method: 'GET' }),
  catalog: () => request({ url: 'system/functionGuides/catalog', method: 'GET' }),
  save: (data: FunctionGuide) => request({ url: 'system/functionGuides', method: 'POST', data })
}
